export default __webpack_public_path__ + "static/media/CNo.56-3.3afc01af.jpg";